import actionTypes from './actionTypes';

const initialState = {
  data: [],
  isCreating: false,
  availableFleets: [
    {
      label: 'Any',
      value: {
        name: 'Any',
        account: null,
      },
    },
  ],
  isFetchingFleets: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.CREATE:
      return {
        ...state,
        isCreating: false,
      };

    case actionTypes.CREATING:
      return {
        ...state,
        isCreating: true,
      };

    case actionTypes.CREATED:
      return {
        ...state,
        isCreating: false,
      };

    case actionTypes.FAILED:
      return {
        ...state,
        isCreating: false,
      };

    case actionTypes.FETCH_FLEETS:
      return {
        ...state,
        isFetchingFleets: true,
      };

    case actionTypes.FETCHED_FLEETS:
      return {
        ...state,
        isFetchingFleets: false,
        availableFleets: action.payload.availableFleets,
      };

    default:
      return state;
  }
};
